export default __webpack_public_path__ + "static/media/Douglas Souza_.24bc320e.png";